import React from 'react';
import { Outlet } from 'react-router';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { PageTopBar } from './components/page-top-bar';
import * as Styled from './goal-detail.style';
import { OutletContext } from './outlet-context';

export const GoalDetail: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.GoalsDetail, undefined);
  const mainScrollRef = React.useRef<HTMLDivElement>(null);

  return (
    <Styled.Container>
      <Styled.Main ref={mainScrollRef}>
        <PageTopBar />

        <Outlet context={{ mainScrollRef } satisfies OutletContext} />
      </Styled.Main>
    </Styled.Container>
  );
};
